import React from 'react';
// @ts-ignore
import styles from './FloatingSubmitButton.module.scss';
import SubmitButton, {
	SubmitButtonProps,
} from '../../../../Components/Button/SubmitButton';

const FloatingSubmitButton: React.FC<SubmitButtonProps> = props => {
	return (
		<div className={styles.wrapper}>
			<SubmitButton {...props} />
		</div>
	);
};

export default FloatingSubmitButton;
